import { PropsWithChildren, TransitionEventHandler, useCallback, useEffect, useRef, useState } from 'react';
import cn from 'classnames';

export type CollapseProps = PropsWithChildren<{
  isExpanded: boolean;
  collapsedSize?: string | number;
  withTransition?: boolean;
  className?: string;
  wrapperClassName?: string;
}>;

export const Collapse = ({
  isExpanded,
  collapsedSize = 0,
  withTransition = true,
  className,
  wrapperClassName,
  children,
}: CollapseProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const [contentHeight, setContentHeight] = useState<number | string>(isExpanded ? 'auto' : collapsedSize);
  useEffect(() => {
    if (ref.current) setContentHeight(ref.current.clientHeight);
  }, [children]);

  // TODO: Track content height change with ResizeObserver or use motion
  const onTransitionEnd = useCallback<TransitionEventHandler<HTMLDivElement>>(() => {
    setContentHeight('auto');
  }, []);

  useEffect(() => {
    if (ref.current && contentHeight === 'auto') setContentHeight(ref.current.clientHeight);
  }, [isExpanded, contentHeight]);

  return (
    <div
      className={cn(wrapperClassName, 'overflow-hidden', { 'transition-height': withTransition })}
      style={{ height: isExpanded ? contentHeight : collapsedSize }}
      onTransitionEnd={onTransitionEnd}
    >
      <div ref={ref} className={className}>
        {children}
      </div>
    </div>
  );
};
